import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EssencePage from './pages/EssencePage';
import OrderPage from './pages/OrderPage';
import StoriesPage from './pages/StoriesPage';
import ReadyForYouPage from './pages/ReadyForYouPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import GlobalStyle from './GlobalStyle';
import { trackPageView } from './analytics';
import {
  LocalBusinessSchema,
  WebSiteSchema,
  OrganizationSchema,
  SiteNavigationSchema
} from './components/SEOHead';

// Títulos de páginas para Google Analytics
const pageTitles = {
  '/': 'Inicio - Duo a Color',
  '/our-essence': 'Nuestra Esencia - Duo a Color',
  '/create-your-story': 'Crea Tu Historia - Duo a Color',
  '/lived-stories': 'Historias Vividas - Duo a Color',
  '/listos-para-ti': 'Listos para Ti - Duo a Color',
  '/contact': 'Contacto - Duo a Color',
  '/politica-privacidad': 'Política de Privacidad - Duo a Color',
};

// Componente interno para tracking de páginas
function AppContent() {
  const location = useLocation();

  useEffect(() => {
    const title = pageTitles[location.pathname] || 'Duo a Color';
    // Actualizar título del documento
    document.title = title;
    // Enviar page view a GA4
    trackPageView(location.pathname, title);
  }, [location]);

  return (
    <>
      <GlobalStyle />
      <LocalBusinessSchema />
      <WebSiteSchema />
      <OrganizationSchema />
      <SiteNavigationSchema />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-essence" element={<EssencePage />} />
          <Route path="/create-your-story" element={<OrderPage />} />
          <Route path="/lived-stories" element={<StoriesPage />} />
          <Route path="/listos-para-ti" element={<ReadyForYouPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;